import { render, staticRenderFns } from "./courseTab.vue?vue&type=template&id=09033ccc&scoped=true&"
import script from "./courseTab.vue?vue&type=script&lang=js&"
export * from "./courseTab.vue?vue&type=script&lang=js&"
import style0 from "./courseTab.vue?vue&type=style&index=0&id=09033ccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09033ccc",
  null
  
)

export default component.exports